module.exports = __webpack_public_path__ + "static/img/file-tir.68bd52c6.svg";